import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';
import { API } from '@/lib/data';

const SettingsContext = createContext(null);

const DEFAULT_SETTINGS = {
  contact: {
    phone: '+90 546 573 99 33',
    whatsapp: '905465739933',
    address: 'Cevizlidere mahallesi, Mevlana Bulvarı, Yıldırım Kule 5. Kat No:221/15, Balgat-Ankara, 06520',
    hours: 'Salı - Cuma: 10:00 - 18:00',
    hours_saturday: 'Cumartesi: 10:00 - 18:00',
    hours_sunday: 'Pazar: Kapalı',
    schedule: [
      { day: 'pazartesi', open: false, start: '10:00', end: '18:00' },
      { day: 'sali', open: true, start: '10:00', end: '18:00' },
      { day: 'carsamba', open: true, start: '10:00', end: '18:00' },
      { day: 'persembe', open: true, start: '10:00', end: '18:00' },
      { day: 'cuma', open: true, start: '10:00', end: '18:00' },
      { day: 'cumartesi', open: true, start: '10:00', end: '18:00' },
      { day: 'pazar', open: false, start: '10:00', end: '18:00' }
    ],
    map_link: 'https://www.google.com/maps/place/YILDIRIM+KULE/@39.8820705,32.8127704,19.5z/data=!4m10!1m2!2m1!1zQ2V2aXpsaWRlcmUgbWFoYWxsZXNpLCBNZXZsYW5hIEJ1bHZhcsSxLCBZxLFsZMSxcsSxbSBLdWxlIE5vOjIyMS8xMTU!3m6!1s0x14d345f0a9aacc8d:0xec882979747ef3b8!8m2!3d39.8821368!4d32.8127235!15sCkRDZXZpemxpZGVyZSBtYWhhbGxlc2ksIE1ldmxhbmEgQnVsdmFyxLEsIFnEsWxkxLFyxLFtIEt1bGUgTm86MjIxLzExNVpEIkJjZXZpemxpZGVyZSBtYWhhbGxlc2kgbWV2bGFuYSBidWx2YXLEsSB5xLFsZMSxcsSxbSBrdWxlIG5vIDIyMSAxMTWSARBjb3Jwb3JhdGVfb2ZmaWNlmgFEQ2k5RFFVbFJRVU52WkVOb2RIbGpSamx2VDIwMWNtSnNVbE5hV0VwUVYyeHZkMXBzU2pSUk0yUlRWbXhrY1dWRlJSQULgAQD6AQQIABBD!16s%2Fg%2F11bycl06k5?entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D',
    email: 'sadedusun@gmail.com',
    maps_url: 'https://maps.google.com/?q=YILDIRIM+KULE+Ankara',
    maps_embed: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d764.5!2d32.8127704!3d39.8820705!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d345f0a9aacc8d:0xec882979747ef3b8!2sYILDIRIM+KULE!5e0!3m2!1str!2str'
  },
  social: {
    youtube: 'https://www.youtube.com/@dr.niluferyldrmlasadedusun9263',
    instagram: 'https://www.instagram.com/profdrniluferyildirim/',
    facebook: 'https://www.facebook.com/sadedusuncom/?locale=tr_TR'
  },
  doctor: {
    image: 'https://customer-assets.emergentagent.com/job_dr-nilufershop/artifacts/rd2kgze0_image.png',
    name: 'Prof. Dr. Nilüfer Yıldırım',
    title: 'Bütüncül Sağlık & Fonksiyonel Tıp',
    bio: 'Hacettepe Üniversitesi mezunu ve Nükleer Tıp Profesörü olan Dr. Yıldırım, akademik kariyerinin ardından odağını kronik hastalıkların kök nedenlerine çevirmiştir. Bilimsel temelli fonksiyonel tıp yaklaşımını HRV analizi ve stres regülasyonu ile harmanlayarak, hastalarının yaşam enerjilerini "SADE" (Sağlıklı, Aktif, Dengeli, Esnek) bir çerçevede yeniden inşa etmelerine rehberlik etmektedir.',
    clinic_approach: 'Klinik yaklaşımımda sizi sadece tahlil sonuçlarınızla değil, tüm yaşam öykünüzle bir bütün olarak dinliyor; kronik sorunlarınızın görünmeyen kök nedenlerine birlikte odaklanıyoruz. Fonksiyonel tıbbın bilimsel rehberliğini HRV analizi gibi modern yöntemlerle birleştirerek, bedensel ve zihinsel dengenizi yeniden kuracak size özel bir yol haritası çiziyoruz. Amacımız, abartıdan uzak ve \'SADE\' (Sağlıklı, Aktif, Dengeli, Esnek) bir yaşam felsefesiyle yaşam enerjinizi kalıcı olarak yükseltmek. Bu iyileşme yolculuğunda size güven ve bilimle eşlik etmek için buradayım.',
    detail_bio: '<p><strong>Prof. Dr. Nilüfer Yıldırım Kimdir?</strong><br></p><p>Tıp eğitimimi Hacettepe Üniversitesi\'nde tamamladıktan sonra Nükleer Tıp uzmanlığımı Gazi Üniversitesi\'nde aldım. Akademik hayatım boyunca nükleer tıbbın tanı ve tedavideki güçlü araçlarını kullanarak özellikle onkoloji ve endokrinoloji alanlarında çalıştım. Ankara Yıldırım Beyazıt Üniversitesi Tıp Fakültesi Nükleer Tıp Anabilim Dalı\'nda öğretim üyeliği yaptım ve profesör unvanı ile emekli oldum. Ulusal ve uluslararası hakemli dergilerde yayımlanmış çok sayıda bilimsel makale ve kitap bölümü ile akademik üretimin içinde aktif olarak yer aldım.<br></p><p>Nükleer tıp bana hastalığa "fonksiyon" üzerinden bakmayı öğretti. Görüntünün arkasındaki fizyolojiyi, biyokimyayı ve hücresel yanıtı anlamaya çalışmak mesleki refleksim haline geldi. Ancak yıllar içinde şunu fark ettim: Kronik hastalıkların artışı yalnızca organ düzeyinde açıklanamaz. Stres, yaşam tarzı, beslenme, uyku ve duygusal yükler çoğu zaman biyokimyasal parametrelerden daha belirleyici olabiliyor.<br></p><p>Bu farkındalık beni fonksiyonel tıp yaklaşımına yönlendirdi. 2020 yılında Fonksiyonel Tıp Akademisi eğitimine katıldım ve sonrasında koruyucu hekimlik ile bütüncül hasta takibini klinik pratiğimin merkezine aldım.</p><p>Bugün kendi muayenehanemde; kronik hastalıkların kök nedenlerini araştıran, laboratuvar verilerini yaşam öyküsü ile birlikte değerlendiren ve kişiye özel, uygulanabilir yol haritaları oluşturan bir yaklaşım benimsiyorum. Amacım "SADE" bir çerçevede (Sağlıklı, Aktif, Dengeli ve Esnek) sürdürülebilir iyilik halini desteklemek.<br></p><p>Ayrıca stres regülasyonu ve otonom denge üzerine çalışıyorum. Kalp hızı değişkenliği (HRV) analizi ile hastalarımda stres düzeyini ölçerek tedavi yaklaşımını kişiselleştiriyorum. Bu alanda Autonom Health tarafından sertifiye edilmiş HRV-Professional ve HeartMath\u00AE Certified Practitioner olarak, zihinsel ve fizyolojik dengeyi birlikte ele alan bilimsel temelli yöntemler kullanıyorum.<br></p><p>Hekimlik benim için yalnızca hastalığı tedavi etmek değil; kişinin yaşam enerjisini yeniden inşa etmesine eşlik etmektir. Bilimsel temelden ödün vermeden, abartıya kaçmadan ve gerçekçi bir yol haritası çizerek ilerlemeyi önemsiyorum. Bu yaklaşımı yalnızca muayenehanemde değil, sosyal medya paylaşımlarımda da sürdürüyorum. Instagram\'da güncel ve anlaşılır sağlık paylaşımları yapıyor, YouTube kanalımda ise bilimsel veriler ışığında, sade ve uygulanabilir bilgiler içeren bilgilendirme videoları hazırlıyorum.<br></p><p>Mesleki hayatımın dışında fotoğrafçılık ve fitness ile ilgileniyorum. Fotoğraf bana bakmayı, fitness ise disiplinli ve dengede kalmayı hatırlatıyor. Belki de hekimliğimin özü de tam olarak bu: Doğru yere bakmak ve dengede kalmak.<br></p><p>Hoş geldiniz.</p><p></p>'
  },
  hero: {
    title: 'Fonksiyonel tıp yaklaşımı ve stres yönetimi ile kişiye özel çözümler',
    subtitle: 'Amacımız bedensel ve zihinsel iyilik haline ulaşmak için SADE (Sağlıklı, Aktif, Dengeli, Esnek) bir rehberlik',
    cert_count: '10+',
    experience_years: '20+'
  },
  kvkk: {
    text: 'KVKK Aydınlatma Metni',
    cookie_text: 'Bu web sitesi, deneyiminizi geliştirmek için çerezler kullanmaktadır. Çerezler, web sitesinin düzgün çalışması için gerekli olan küçük metin dosyalarıdır.\n\nSunulan hizmetlerden yararlanabilmeniz için ad-soyad, iletişim bilgilerinizin girişinin yapılması istenmekte ve bu kişisel verileriniz işlenmektedir.\n\nSitemizi kullandığınızda kişisel verilerinizin işlenmesini ve çerez kullanımımızı kabul etmiş olacaksınız.'
  },
  homepage_sections: {
    services_title: 'Tedavilerimiz',
    services_subtitle: 'Size en uygun programı birlikte belirleyelim.',
    assessment_title: 'Sizin için hangi tedavi hizmeti daha uygun?',
    assessment_subtitle: 'Belirtilerinizi 1-5 arası puanlayın, genel değerlendirme ile size en uygun hizmeti anında görün.',
    process_title: '4 Adımda Sağlık Yolculuğu',
    process_subtitle: 'Dört adımda sağlık yolculuğunuz.',
    videos_title: 'Video İçerikler',
    videos_subtitle: 'Fonksiyonel tıp hakkında bilgilendirici videolar.',
    blog_title: 'İçeriklerden Seçmeler',
    blog_subtitle: 'Sağlık ve yaşam kalitesi üzerine yazılar.',
    news_title: 'Haberler & Kongreler',
    news_subtitle: 'Güncel gelişmeler ve katılımlar.',
    certs_title: 'Diploma & Sertifikalar',
    certs_subtitle: 'Akademik ve profesyonel yetkinlikler.',
    faq_title: 'Sık Sorulan Sorular',
    faq_subtitle: 'Sık karşılaştığımız sorular ve yanıtlarını aşağıda bulabilirsiniz. Danışma süreci ile ilgili burada yer almayan sorularınız varsa sadedusun@gmail.com e-posta adresine gönderebilirsiniz.',
    contact_title: 'Randevu & İletişim',
    contact_subtitle: 'Sorularınız ve randevu talepleriniz için aşağıdaki formu doldurun veya doğrudan iletişime geçin.'
  },
  emailjs: {
    service_id: '',
    template_id: '',
    public_key: '',
    notification_email: 'sadedusun@gmail.com'
  },
  reels: {
    title: 'Kısa İçerikler',
    subtitle: 'Sağlık ipuçları ve bilgilendirici kısa videolar',
    items: [
      { url: 'https://www.youtube.com/shorts/QvwSpDeYZ0g' },
      { url: 'https://www.youtube.com/shorts/Xv8A7kMgVi4' },
      { url: 'https://www.youtube.com/shorts/c7x657SQUXU' },
      { url: 'https://www.youtube.com/shorts/4_FoY72J3c8' }
    ]
  },
  corporate_cta: {
    title: 'Konferans, Seminer veya Medya Daveti',
    description: 'TV programları, kurumsal seminerler, kongreler veya eğitim etkinlikleri için Prof. Dr. Nilüfer Yıldırım\'ı davet etmek isterseniz bizimle iletişime geçin.',
    button_text: 'İletişime Geçin'
  },
  sade_dusun: {
    title: 'Sade Düşün, Sade Yaşa',
    description: 'SADE felsefesiyle — Sağlıklı, Aktif, Dengeli, Esnek — yaşamınızı yeniden şekillendirin. Bilimsel temelli fonksiyonel tıp yaklaşımı ile kişiye özel danışmanlık programı.',
    link_text: 'Danışmanlık hakkında bilgi alın'
  },
  hero_banner: {
    items: [
      { text: 'Fonksiyonel Tıp Akademisi', icon: 'GraduationCap' },
      { text: 'HeartMath\u00AE Certified', icon: 'Award' },
      { text: 'Nükleer Tıp', icon: 'ShieldCheck' }
    ]
  },
  process_steps: [
    { id: '1', step: 1, title: 'İlk Görüşme', icon: 'MessageCircle', description: '' },
    { id: '2', step: 2, title: 'Analiz ve Yol Haritası', icon: 'ClipboardList', description: '' },
    { id: '3', step: 3, title: 'Uygulama ve Takip', icon: 'FileText', description: '' },
    { id: '4', step: 4, title: 'Koruma ve Optimizasyon', icon: 'TrendingUp', description: '' }
  ]
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    axios.get(`${API}/settings`)
      .then(r => {
        if (r.data) setSettings(prev => ({ ...prev, ...r.data }));
      })
      .catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext) || DEFAULT_SETTINGS;
}
